import { Flex, Spinner } from "@radix-ui/themes";
import { FC, JSX } from "react";

const Loader: FC = (): JSX.Element => {
  return (
    <Flex align={"center"} justify={"center"}>
      <Spinner />
    </Flex>
  );
};

export default Loader;
